import get from 'lodash/get';

import { dialogueMsg } from '../validationMessages';

const MAX_WORD_LENGTH = 45;

function isDialogueTooLong(sentence) {
  const words = sentence.split(' ');
  for (const word of words) {
    if (word.length > MAX_WORD_LENGTH) {
      return true;
    }
  }
  return false;
}

function validateDialogue(caseConf) {
  const warnings = [];
  const errors = [];

  if (caseConf.dialogue.aiEnabled) {
    // Paitent Prompt
    const promptContent = get(caseConf.dialogue, 'patientPrompt.content.en');
    if (!promptContent) {
      errors.push(dialogueMsg('Patient prompt cannot be empty', null));
    }
    // Questions
    const questions = caseConf.dialogue.aiQuestions || [];
    for (const question of questions) {
      if (!question.content.en) {
        errors.push(dialogueMsg('Empty question', question.id, { errorId: 'missingQuestion' }));
      } else if (isDialogueTooLong(question.content.en)) {
        errors.push(dialogueMsg(`Question has word that exceeds ${MAX_WORD_LENGTH} characters in length`, question.id, { errorId: 'wordTooLong'}));
      }
      if (!question.options.reason || !question.options.reason.en) {
        errors.push(dialogueMsg('Provide AI with reason for response', question.id, { errorId: 'missingReason' }));
      }
    }
    // Unsolicited
    const unsolicited = caseConf.dialogue.aiUnsolicited || [];
    for (const item of unsolicited) {
      if (!item.options.reason || !item.options.reason.en) {
        errors.push(dialogueMsg('Provide AI with reason for response.', item.id, { errorId: 'missingReason' }))
      }
    }
  } else {
    const questions = caseConf.dialogue.questions || [];
    for (const question of questions) {
      if (!question.content.en) {
        errors.push(dialogueMsg('Empty question', question.id, { errorId: 'missingQuestion' }));
      } else if (isDialogueTooLong(question.content.en)) {
        errors.push(dialogueMsg(`Question has word that exceeds ${MAX_WORD_LENGTH} characters in length`, question.id, { errorId: 'wordTooLong'}));
      }
    }

    const commands = caseConf.dialogue.commands || [];
    for (const command of commands) {
      if (!command.content.en) {
        warnings.push(dialogueMsg('Empty command', command.id, { warningId: 'missingQuestion' }));
      } else if (isDialogueTooLong(command.content.en)) {
        errors.push(dialogueMsg(`Command has word that exceeds ${MAX_WORD_LENGTH} characters in length`, command.id, { errorId: 'wordTooLong'}));
      }
    }
  }

  const calls = caseConf.dialogue.calls || [];
  for (const call of calls) {
    for (const item of call.items) {
      if (!item.content.en) {
        warnings.push(dialogueMsg('Empty call question', item.id, { warningId: 'missingQuestion' }))
      } else if (isDialogueTooLong(item.content.en)) {
        errors.push(dialogueMsg(`Call question has word that exceeds ${MAX_WORD_LENGTH} characters in length`, item.id, { errorId: 'wordTooLong' }));
      }
    }
  }

  return {
    errors,
    warnings,
  };
}

export default validateDialogue;
